export class PortalProfile {
    UserName: string;
    UserId: string;
    FullName: string;
    Address: string;
    Fax: string;
    Organization: string;
    Email: string;
    RegisterTypeId: number;
    PortalUserTypeId: number;
    CountryId: number;
    Mobile: string;
    ConfirmationCode: string;
    IsConfirmed: boolean;
}